module.exports = __webpack_public_path__ + "static/media/fly0165.201195c1.webp";